module.exports = __webpack_public_path__ + "static/media/feedback-error.6ae73fb6.png";